// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardInput-module_cardContainer__QWg6F {
    width: 100%;
    max-width: 552px;
    min-height: 200px;
    max-height: 288px;
    aspect-ratio: 1.6;
    box-sizing: border-box;
    margin-bottom: 8px;
    padding: 24px;
    border: 1px solid var(--grey_16_tr);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: var(--white);

    @media screen and (min-width: 1440px) {
        padding: 32px;
        border-radius: 16px;
        margin-bottom: 16px;
    }
}

.cardInput-module_cardRow__lTloR {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-bottom: 24px;
    min-height: 24px;

    &:last-child {
        margin-bottom: 0;
    }

    &.cardInput-module_justifyEnd__WsZfk {
        justify-content: flex-end;
    }
    &.cardInput-module_alignStart__Z_5CL {
        align-items: start;
    }
}

.cardInput-module_cardRowInput__y7dhG {
    flex: 1;
}

.cardInput-module_cardExpiredDate__d0A0q {
    width: 80px;
    margin-left: 24px;
    flex-shrink: 0;
}

.cardInput-module_hintWrapper__TDSSU {
    display: inline-flex;
    align-items: center;
}

.cardInput-module_hintContainer__eslNa {
    font: var(--typography-secondary);
    color: var(--grey_72_lc);
    margin-top: 8px;
    margin-left: 16px;
    margin-right: 16px;
    display: flex;

    &.cardInput-module_isError__bFdps {
        color: var(--pink_100);
    }
}

.cardInput-module_iconWrapper__HvLXU {
    margin-top: 16px;
    cursor: pointer;
}

.cardInput-module_inputRightButton__tJi3G {
    background: none;
    border: none;
    outline: none;
    padding: 8px;
    cursor: pointer;
}

.cardInput-module_simpleHintRow__pxS0V {
    margin-top: 8px;
    margin-left: 16px;
}

.cardInput-module_simpleHintIcon__SN8yZ {
    display: inline-flex;
    width: 20px;
    height: 20px;
    margin-left: 4px;
    vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Card/cardInput.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;;IAE9B;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;;IAEhB;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;;IAEb;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":[".cardContainer {\n    width: 100%;\n    max-width: 552px;\n    min-height: 200px;\n    max-height: 288px;\n    aspect-ratio: 1.6;\n    box-sizing: border-box;\n    margin-bottom: 8px;\n    padding: 24px;\n    border: 1px solid var(--grey_16_tr);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: var(--white);\n\n    @media screen and (min-width: 1440px) {\n        padding: 32px;\n        border-radius: 16px;\n        margin-bottom: 16px;\n    }\n}\n\n.cardRow {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    margin-bottom: 24px;\n    min-height: 24px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    &.justifyEnd {\n        justify-content: flex-end;\n    }\n    &.alignStart {\n        align-items: start;\n    }\n}\n\n.cardRowInput {\n    flex: 1;\n}\n\n.cardExpiredDate {\n    width: 80px;\n    margin-left: 24px;\n    flex-shrink: 0;\n}\n\n.hintWrapper {\n    display: inline-flex;\n    align-items: center;\n}\n\n.hintContainer {\n    font: var(--typography-secondary);\n    color: var(--grey_72_lc);\n    margin-top: 8px;\n    margin-left: 16px;\n    margin-right: 16px;\n    display: flex;\n\n    &.isError {\n        color: var(--pink_100);\n    }\n}\n\n.iconWrapper {\n    margin-top: 16px;\n    cursor: pointer;\n}\n\n.inputRightButton {\n    background: none;\n    border: none;\n    outline: none;\n    padding: 8px;\n    cursor: pointer;\n}\n\n.simpleHintRow {\n    margin-top: 8px;\n    margin-left: 16px;\n}\n\n.simpleHintIcon {\n    display: inline-flex;\n    width: 20px;\n    height: 20px;\n    margin-left: 4px;\n    vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `cardInput-module_cardContainer__QWg6F`,
	"cardRow": `cardInput-module_cardRow__lTloR`,
	"justifyEnd": `cardInput-module_justifyEnd__WsZfk`,
	"alignStart": `cardInput-module_alignStart__Z_5CL`,
	"cardRowInput": `cardInput-module_cardRowInput__y7dhG`,
	"cardExpiredDate": `cardInput-module_cardExpiredDate__d0A0q`,
	"hintWrapper": `cardInput-module_hintWrapper__TDSSU`,
	"hintContainer": `cardInput-module_hintContainer__eslNa`,
	"isError": `cardInput-module_isError__bFdps`,
	"iconWrapper": `cardInput-module_iconWrapper__HvLXU`,
	"inputRightButton": `cardInput-module_inputRightButton__tJi3G`,
	"simpleHintRow": `cardInput-module_simpleHintRow__pxS0V`,
	"simpleHintIcon": `cardInput-module_simpleHintIcon__SN8yZ`
};
export default ___CSS_LOADER_EXPORT___;
